import Alpine from 'alpinejs'

const faqManager = (initialData = {}) => ({
  existingFaqsCount: initialData.existingFaqsCount || 0,
  existingFaqs: initialData.existingFaqs || [],
  newFaqs: [],
  removedFaqIds: [],
  _savedPosition: null,

  nextPosition() {
    const existingActiveCount = this.existingFaqsCount - this.removedFaqIds.length
    return existingActiveCount + this.newFaqs.length + 1
  },

  swapExistingFaqPosition(faqId, newPosition) {
    const faq = this.existingFaqs.find(f => f.id === faqId)
    if (!faq) return

    const oldPosition = faq.position
    newPosition = parseInt(newPosition)
    if (oldPosition === newPosition || isNaN(newPosition)) return

    const conflict = this._findConflict(newPosition, { existingId: faqId })

    faq.position = newPosition

    if (conflict) {
      this._setConflictPosition(conflict, oldPosition)
    }
  },

  swapNewFaqPosition(tempId, oldPosition) {
    const faq = this.newFaqs.find(f => f.tempId === tempId)
    if (!faq) return

    const newPosition = faq.position
    if (oldPosition === newPosition) return

    const conflict = this._findConflict(newPosition, { newTempId: tempId })

    if (conflict) {
      this._setConflictPosition(conflict, oldPosition)
    }
  },

  _findConflict(position, exclude) {
    const existingConflict = this.existingFaqs.find(f =>
      f.position === position &&
      f.id !== exclude.existingId &&
      !this.removedFaqIds.includes(String(f.id))
    )
    if (existingConflict) return { type: 'existing', faq: existingConflict }

    const newConflict = this.newFaqs.find(f =>
      f.position === position && f.tempId !== exclude.newTempId
    )
    if (newConflict) return { type: 'new', faq: newConflict }

    return null
  },

  _setConflictPosition(conflict, position) {
    conflict.faq.position = position
  },

  _reindexPositions() {
    const activeExisting = this.existingFaqs
      .filter(f => !this.removedFaqIds.includes(String(f.id)))
    const all = [
      ...activeExisting.map(f => ({ ref: f, type: 'existing' })),
      ...this.newFaqs.map(f => ({ ref: f, type: 'new' }))
    ]
    all.sort((a, b) => a.ref.position - b.ref.position)
    all.forEach((item, i) => {
      item.ref.position = i + 1
    })
  },

  addFaq() {
    this.newFaqs.push({
      tempId: Date.now(),
      position: this.nextPosition(),
      faq_category_id: '',
      categoryName: '',
      question: '',
      answer: ''
    })
    this._reindexPositions()
  },

  removeNewFaq(tempId) {
    this.newFaqs = this.newFaqs.filter(f => f.tempId !== tempId)
    this._reindexPositions()
  },

  markExistingFaqForRemoval(faqId) {
    this.removedFaqIds.push(faqId)
    this._reindexPositions()
  },

  isExistingFaqRemoved(faqId) {
    return this.removedFaqIds.includes(faqId)
  },

  existingFaqOrder(faqId) {
    const faq = this.existingFaqs.find(f => f.id === faqId)
    return faq ? faq.position : 0
  }
})

Alpine.data('faqManager', faqManager)
export default faqManager
